import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.995 4.85A2 2 0 0 0 26 3H8l-.15.005A2 2 0 0 0 6 5v2.049L4 7.05l-.117.007A1 1 0 0 0 4 9.05l2-.001v3l-2 .001-.117.007A1 1 0 0 0 4 14.05l2-.001v3l-2 .001-.117.007A1 1 0 0 0 4 19.05l2-.001v3l-2 .001-.117.007A1 1 0 0 0 4 24.05l2-.001V27l.005.15A2 2 0 0 0 8 29h18l.15-.006A2 2 0 0 0 28 27V5zM8 5h18v22H8zm9 4a5 5 0 0 1 3.367 8.696A8.5 8.5 0 0 1 23.8 20.4a1 1 0 0 1-1.6 1.2 6.5 6.5 0 0 0-4.913-2.593L16.99 19l-.256.006A6.5 6.5 0 0 0 11.8 21.6a1 1 0 1 1-1.6-1.2 8.5 8.5 0 0 1 3.433-2.705A5 5 0 0 1 17 9m-3 5a3 3 0 1 1 3.018 3h-.026l-.168-.005A3 3 0 0 1 14 14"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCustomerContacts = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCustomerContacts);
export default Memo;
